import React, { useRef, useEffect, } from 'react';
import SunEditor, {buttonList} from 'suneditor-react';
import 'suneditor/dist/css/suneditor.min.css'; // Import Sun Editor's CSS File

class RichEditor extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      content: props.content
    }    
  }

  setContent = async (content) => {
    this.props.setHtml(content);
  };

  render() {
    const { content } = this.state;

    return (     
        <div>
          <SunEditor  
            setContents={content}
            onChange={this.setContent}
            enableToolbar={true} 
            setOptions={{
              height: 200,
              buttonList: buttonList.complex, // Or Array of button list, eg. [['font', 'align'], ['image']]
              minHeight: 500,
            }} />
          <p/>
        </div>
    );
  }
}

export default RichEditor;
